/**
 * Executor to execute plugin from dom elements
 */
export default class {
  constructor (namespace, parser) {
    this.ns = namespace
    this.parser = parser
  }

  _toPluginNS (name) {
    return this.ns + name.charAt(0).toUpperCase() + name.slice(1)
  }

  /**
   * execute the plugins on the given element.
   * If multiple plugins are defined on the element.
   * All plugins will be executed.
   *
   * @param element this elements plugins will be executed.
   */
  execute (element) {
    // single plugin definition ?
    const plugin = this.parser.readPlugin(element, this.ns)
    if (plugin) {
      this.executePlugin(element, plugin)

      /*
       * don't execute multiple plugin definitons,
       * if a single plugin definition was found.
       */
      return
    }

    // multiple plugin definitions ?
    const plugins = this.parser.readPlugins(element, this.ns)
    if (plugins) {
      plugins.forEach(p => {
        this.executePlugin(element, p)
      })
    }
  }

  /**
   * Executes the given plugin and its pipedPlugins
   *
   * @param element
   * @param plugin
   * @param (optional) pipedValue
   */
  executePlugin (element, plugin, pipedValue) {
    // read options and execute
    const options = this.parser.readOptions(element, this._toPluginNS(plugin.name), {})

    // plugins must be defined unter window.jetjs.plugins.<NAME>
    if (window.jetjs && window.jetjs.plugins && window.jetjs.plugins[plugin.name]) {
      // execution
      const result = window.jetjs.plugins[plugin.name].apply({
        // TODO: Listener mechanism to update Piped values ?
        // plugins should do something like: this.onPipedValueChange(newValue => doSomething(nwValue))
      }, [element, options, pipedValue])

      // execute piped plugins (recursive, because piped plugins can have piped plugins itself)
      plugin.pipedPlugins.forEach(p => {
        this.executePlugin(element, p, result)
      })
    } else {
      console.error('Plugin ', plugin.name, ' cannot be found. Make sure its already loaded.')
    }
  }

  /**
   *
   * @param {*} elements
   */
  executeAll (elements) {
    elements.forEach((el) => this.execute(el))
  }
}
